import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetMyStore = () => {

    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/admin/store/my`)
    }, [])

    return [fetchResult]
}

export default useGetMyStore